import { FlagsPermissionCargoV2 } from "@/feature-flags/flags-permission-cargo-v2";
import { h, resolveComponent } from "vue";

const Layout = () =>
  import(/* webpackChunkName: "Layout" */ "@/app/ui/layout/index.vue");

const CargoV2CreateIndex = () =>
  import(
    /* webpackChunkName: "CargoV2" */ "@/app/ui/views/cargo-v2/create/index.vue"
  );
const CargoV2CreateRtc = () =>
  import(
    /* webpackChunkName: "CargoV2" */ "@/app/ui/views/cargo-v2/create/rtc.vue"
  );
const CargoV2CreateManual = () =>
  import(
    /* webpackChunkName: "CargoV2" */ "@/app/ui/views/cargo-v2/create/manual.vue"
  );
const CargoV2Detail = () =>
  import(
    /* webpackChunkName: "CargoV2" */ "@/app/ui/views/cargo-v2/detail.vue"
  );
const CargoV2Edit = () =>
  import(/* webpackChunkName: "CargoV2" */ "@/app/ui/views/cargo-v2/edit.vue");
const CargoV2Rebooking = () =>
  import(
    /* webpackChunkName: "CargoV2" */ "@/app/ui/views/cargo-v2/rebooking.vue"
  );
const CargoV2TabRtcPlane = () =>
  import(
    /* webpackChunkName: "CargoV2" */ "@/app/ui/views/cargo-v2/create/tab-rtc-plane.vue"
  );
const CargoV2TabRtcTruck = () =>
  import(
    /* webpackChunkName: "CargoV2" */ "@/app/ui/views/cargo-v2/create/tab-rtc-truck.vue"
  );
const CargoV2TabRtcShip = () =>
  import(
    /* webpackChunkName: "CargoV2" */ "@/app/ui/views/cargo-v2/create/tab-rtc-ship.vue"
  );
const CargoV2CreateSearchFlight = () =>
  import(
    /* webpackChunkName: "CargoV2" */ "@/app/ui/views/cargo-v2/create/search-flight.vue"
  );

const CargoV2DetailInfo = () =>
  import(
    /* webpackChunkName: "CargoV2" */ "@/app/ui/views/cargo-v2/components/cargo-v2-detail-info.vue"
  );

const CargoV2DetailHistory = () =>
  import(
    /* webpackChunkName: "CargoV2" */ "@/app/ui/views/cargo-v2/components/cargo-v2-detail-history.vue"
  );

export default [
  // LIST RTC
  {
    path: "/cargo-v2",
    component: Layout,
    name: "cargo-v2-create",
    meta: {
      hidden: true,
      parent: "Booking Kargo",
      permission: [FlagsPermissionCargoV2.permission_cargo_v2_create]
    },
    children: [
      {
        path: "create",
        redirect: "/cargo-v2/create/plane",
        name: "cargo-v2-create",
        component: CargoV2CreateIndex,
        meta: {
          header: true,
          title: "Booking Kargo | Create ",
          name: "Booking Kargo",
          before: "/cargo-v2",
          noPaddingWithBreadcrumbV2: true,
          newLayout: true
        },
        children: [
          {
            path: "plane",
            name: "cargo-v2-create-plane",
            component: CargoV2TabRtcPlane,
            meta: { header: true }
          },
          {
            path: "truck",
            name: "cargo-v2-create-truck",
            component: CargoV2TabRtcTruck,
            meta: { header: true }
          },
          {
            path: "ship",
            name: "cargo-v2-create-ship",
            component: CargoV2TabRtcShip,
            meta: { header: true }
          }
        ]
      }
    ]
  },
  // CREATE
  {
    path: "/cargo-v2",
    component: Layout,
    name: "cargo-v2-create-rtc-edit",
    meta: {
      hidden: true,
      parent: "Booking Kargo",
      permission: [FlagsPermissionCargoV2.permission_cargo_v2_create]
    },
    children: [
      {
        path: "create/rtc",
        name: "cargo-v2-create-rtc-edit",
        component: {
          render() {
            return h(resolveComponent("router-view"));
          }
        },
        meta: {
          header: true,
          parent: "cargoV2.create.index.title",
          "parent-path": "/cargo-v2/create"
        },
        children: [
          {
            path: ":id",
            name: "cargo-v2-create-rtc-edit-children",
            component: CargoV2CreateRtc,
            meta: {
              header: true,
              title: "Booking Kargo | Create RTC",
              before: "/cargo-v2/create",
              pathBefore: "cargoV2.create.index.title",
              permission: [FlagsPermissionCargoV2.permission_cargo_v2_create],
              noPaddingWithBreadcrumbV2: true,
              newLayout: true
            }
          }
        ]
      },
      {
        path: "create/rtc/:id/search-flight",
        name: "cargo-v2-create-rtc-edit-search-flight",
        component: CargoV2CreateSearchFlight,
        meta: {
          header: true,
          title: "Booking Kargo | Pilih jadwal",
          name: "Pilih jadwal",
          before: "/cargo-v2/create/rtc/:id",
          noPaddingWithBreadcrumbV2: true,
          newLayout: true
        }
      }
    ]
  },
  // search-flight
  {
    path: "/cargo-v2",
    component: Layout,
    name: "cargo-v2-create-rtc",
    meta: {
      hidden: true,
      parent: "Booking Kargo",
      permission: [FlagsPermissionCargoV2.permission_cargo_v2_create]
    },
    children: [
      {
        path: "create/search-flight",
        name: "cargo-v2-create-search-flight",
        component: CargoV2CreateSearchFlight,
        meta: {
          header: true,
          title: "Booking Kargo | Pilih jadwal",
          name: "cargoV2.create.common.selectSchedule",
          before: "/cargo-v2/create",
          noPaddingWithBreadcrumbV2: true,
          newLayout: true
        }
      },
      {
        path: "create/manual/search-flight",
        name: "cargo-v2-create-manual-search-flight",
        component: CargoV2CreateSearchFlight,
        meta: {
          header: true,
          title: "Booking Kargo | Pilih jadwal",
          name: "Pilih jadwal",
          before: "/cargo-v2/create/manual",
          noPaddingWithBreadcrumbV2: true,
          newLayout: true
        }
      },
      {
        path: ":id/rebooking/search-flight",
        name: "cargo-v2-create-rebooking-search-flight",
        component: CargoV2CreateSearchFlight,
        meta: {
          header: true,
          title: "Booking Kargo | Pilih jadwal",
          name: "Pilih jadwal",
          before: "/cargo-v2/:id/rebooking",
          noPaddingWithBreadcrumbV2: true,
          newLayout: true
        }
      }
    ]
  },
  {
    path: "/cargo-v2",
    component: Layout,
    name: "cargo-v2-create-manual",
    meta: {
      hidden: true,
      parent: "Booking Kargo",
      noPaddingWithBreadcrumbV2: true,
      newLayout: true,
      permission: [FlagsPermissionCargoV2.permission_cargo_v2_create]
    },
    children: [
      {
        path: "create/manual",
        name: "cargo-v2-create-manual",
        component: CargoV2CreateManual,
        meta: {
          header: true,
          title: "Booking Kargo | Create",
          name: "Booking Kargo",
          before: "/cargo-v2"
        }
      }
    ]
  },
  // DETAIL
  {
    path: "/cargo-v2",
    component: Layout,
    name: "cargo-v2-detail",
    meta: {
      hidden: true,
      parent: "Booking Kargo",
      permission: [FlagsPermissionCargoV2.permission_cargo_v2_detail],
      noPaddingWithBreadcrumbV2: true,
      newLayout: true
    },
    children: [
      {
        path: ":id",
        name: "cargo-v2-detail",
        component: CargoV2Detail,
        meta: {
          header: true,
          title: "Booking Kargo | Detail"
        },
        children: [
          {
            path: "info",
            name: "info",
            component: CargoV2DetailInfo,
            meta: {
              header: true
            }
          },
          {
            path: "history",
            name: "history",
            component: CargoV2DetailHistory,
            meta: {
              header: true
            }
          }
        ]
      }
    ]
  },
  // EDIT
  {
    path: "/cargo-v2",
    component: Layout,
    name: "cargo-v2-edit",
    meta: {
      hidden: true,
      parent: "Booking Kargo",
      permission: [FlagsPermissionCargoV2.permission_cargo_v2_detail],
      noPaddingWithBreadcrumbV2: true,
      newLayout: true
    },
    children: [
      {
        path: ":id/edit",
        name: "cargo-v2-edit",
        component: CargoV2Edit,
        meta: {
          header: true,
          title: "Booking Kargo | Edit ",
          name: "Edit Booking Kargo"
        }
      }
    ]
  },
  // REBOOKING
  {
    path: "/cargo-v2",
    component: Layout,
    name: "cargo-v2-rebooking",
    meta: {
      hidden: true,
      parent: "Booking Kargo",
      permission: [FlagsPermissionCargoV2.permission_cargo_v2_create]
    },
    children: [
      {
        path: ":id",
        name: "cargo-v2-rebooking",
        component: {
          render() {
            return h(resolveComponent("router-view"));
          }
        },
        meta: {
          header: true,
          parent: "cargoV2.create.index.title"
        },
        children: [
          {
            path: "rebooking",
            name: "cargo-v2-rebooking-children",
            component: CargoV2Rebooking,
            meta: {
              header: true,
              title: "Booking Kargo | Booking Ulang",
              name: "Booking Ulang",
              before: "/cargo-v2/create",
              pathBefore: "cargoV2.create.index.title",
              noPaddingWithBreadcrumbV2: true,
              newLayout: true
            }
          }
        ]
      }
    ]
  }
];
